<template>
    <li class="col-12-12 purchaseBtns" :class="btnwrapClass">
        <a v-if="btn1title" :href="[btn1url ? (btn1url) : '#']" class="button purchase ae-6 fromLeft w-spc20 inline-block text-center border-solid border border-black uppercase text-size11 font-anonymouse font-medium tracking-spc7 leading-lh5 h-spc21 py-3 px-spc22 opacity-100 hover:bg-black hover:text-white" :class="btn1class">
            {{btn1title}}
        </a>
        <a v-if="btn2title" :href="[btn2url ? (btn2url) : '#']" class="button purchase purchase2 ae-6 fromRight w-spc20 inline-block text-center border-solid border border-black uppercase text-size11 font-anonymouse font-medium tracking-spc7 leading-lh5 h-spc21 py-3 px-spc22 opacity-100 hover:bg-black hover:text-white ml-spc23" :class="btn2class">
            {{btn2title}}
        </a>
    </li>
</template>

<script>
    export default {
        props: [
            'btn1title',
            'btn1url',
            'btn2title',
            'btn2url',
            'btnwrapClass',
            'btn1class',
            'btn2class',
        ],
        name: "SectionDetailsButtons"
    }
</script>

<style scoped>

</style>